import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../../components/NavBar";
import Login from "../../../root/Login";
import {Button, Card, Table} from "antd";
import Colors from "../../../../styles/Colors";
import {BiArrowBack, BiPlus, BiSave, BiUpload} from "react-icons/bi";
import {ColumnsType, TableProps} from "antd/es/table";
import {PostAlgoritmix} from "../../../../dao/multilleure/PostAlgoritmix";
import AlgoritmixModel from "../../../../model/multilleure/AlgoritmixModel";
import {PutAlgoritmix} from "../../../../dao/multilleure/PutAlgoritmix";

interface ActivitatProps {
    checkDadesAlg: () => void;
}


const CarregaAlgoritmix :  React.FC<ActivitatProps>  = ({checkDadesAlg}) => {
    const titol: string = "Càrrega Nova Remesa (.xlsx)";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<AlgoritmixModel[]>([]);
    const [selected, setSelected] = useState<AlgoritmixModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [upload, setUpload] = useState(false);
    const [total, setTotal] = useState(0.00);
    const [visible, setVisible] = useState(true);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);


    useEffect(() => {
        handleLoadingChange(true)
        if(isLoggedIn){
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        //const dades = await GetUsuaris();
        //setDades(dades);
        //await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
        if (visible) setTotal(0.0);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: AlgoritmixModel[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.id,
            value: element.apellido1,
        }));
        //setNomFiltres(ingredientNames);
    }

    const columns: ColumnsType<AlgoritmixModel> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nombre',
            width: 30
        },
        {
            key: 'cognom 1',
            title: 'Cognom 1',
            dataIndex: 'apellido1',
            width: 30
        },
        {
            key: 'cognom 2',
            title: 'Cognom 2',
            dataIndex: 'apellido2',
            responsive: ['lg'],
            width: 30
        },
        {
            key: 'curs',
            title: 'Curs',
            dataIndex: 'curso',
            width: 30
        },
        {
            key: 'tarifa',
            title: 'Preu',
            dataIndex: 'tarifa',
            sorter: (a, b) => a.descompte - b.descompte,
            width: 10
        },
        {
            key: 'descompte',
            title: 'Descompte',
            dataIndex: 'descompte',
            sorter: (a, b) => a.descompte - b.descompte,
            width: 10
        },
    ];

    const tableProps: TableProps<AlgoritmixModel> = {
        loading
    };

    const onChange: TableProps<AlgoritmixModel>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    /*const expandedRowRender2 = (ele: AlgoritmixModel) => {
        return (
            <PlantillaLista element={ele}/>
        );
    };*/

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
            setUpload(true);
        }
    };

    const handleFileUpload = async () => {
        if (selectedFile && selectedFile.name.endsWith(".xlsx")) {
            await handleLoadingChange(true);
            const formData = new FormData();
            formData.append('file', selectedFile);
            await setDades(await PostAlgoritmix(formData, page));
            await handleLoadingChange(false);
        } else {
            alert("Especifica un fitxer .xlsx");
        }
    };

    function changeTotal(selectedRows: AlgoritmixModel[]) {
        console.log(selectedRows);
        let tarifa = 0.0;
        selectedRows.forEach((value) => {
            tarifa += parseFloat(value.tarifa);
        });
        setTotal(parseFloat(tarifa.toFixed(2)));
    }

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: AlgoritmixModel[]) => {
            changeTotal(selectedRows);
            setSelected(selectedRows);
        }
    };

    function handleCancel() {
        setSelectedFile(null);
        setUpload(false);
    }

    async function handleGuardar() {
        if (selected.length === 0) {
            alert("Carrega un fitxer .xlsx i selecciona els usuaris a guardar");
        } else {
            await handleLoadingChange(true)
            await PutAlgoritmix(selected, page);
            await checkDadesAlg();
            await handleLoadingChange(false);
        }
    }

    //TODO: Que aparegui el total a la pantalla

    if (isLoggedIn) {
        return (
            <Card bordered={true} className={"elemento"}>
                <div className={"actionButtons "}>
                    <input type="file"
                           className={""}
                           onChange={handleFileChange}
                           hidden={upload}/>
                    {" "}
                    <Button title={"Tornar a pujar fitxer"}
                            style={{backgroundColor: Colors.colors.color2}}
                            hidden={!upload}
                            onClick={handleCancel}>
                        <BiArrowBack/>
                    </Button>
                    {" "}
                    <Button title={"Carregar Dades"}
                            style={{backgroundColor: Colors.colors.color4}}
                            hidden={!upload}
                            onClick={handleFileUpload}>
                        <BiUpload/>
                    </Button>
                    {" "}
                    <Button title={"Generar Rebut"}
                            style={{backgroundColor: Colors.colors.color5}}
                            hidden={!upload}
                            onClick={handleGuardar}>
                        <BiPlus/>
                    </Button>
                </div>
                <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                {visible && (
                    <Table
                        {...tableProps}
                        rowSelection={{
                            type: 'checkbox',
                            ...rowSelection,
                        }}
                        onChange={onChange}
                        columns={columns}
                        //expandable={{
                        //expandedRowRender: (record) =>
                        //expandedRowRender2(record),
                        //rowExpandable: (record) => true,

                        //}}
                        pagination={{pageSize: 100}}
                        scroll={{y: 400}}
                        dataSource={coleccio}
                    />
                )}
                <p>Preu total: {parseFloat(total.toFixed(2))} eur</p>
            </Card>

        );
    } else {
        return (
            <Login/>
        );
    }
};
export default CarregaAlgoritmix;
